// extracted by mini-css-extract-plugin
export default {"maxApprove":"MaxApprove_maxApprove__z0YwW","tooltip":"MaxApprove_tooltip__EujLf"};